module.exports = __webpack_public_path__ + "img/XAU.45d8d028.png";